import React, { ReactNode, useState } from 'react'
import { SquareButton } from '../../../styles/ButtonStyles'
import { Button, Drawer, Stack, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import ScheduleViewInfo from './schedule/ScheduleViewInfo'
import { ArrowBack, InfoOutlined } from '@mui/icons-material'
import { t } from 'i18next'
import WorklogViewInfo from './worklog/WorklogViewInfo'

type Variant = 'schedule' | 'worklog'

const content: Record<Variant, ReactNode> = {
  schedule: <ScheduleViewInfo />,
  worklog: <WorklogViewInfo />,
}

type InfoSidebarProps = {
  variant: Variant
  size: 'small' | 'medium' | 'large'
}

const InfoSidebar = ({ variant, size = 'medium' }: InfoSidebarProps) => {
  const [open, setOpen] = useState<boolean>(false)
  const theme = useTheme()
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))

  const handleOpen = () => setOpen(true)

  const handleClose = () => setOpen(false)

  return (
    <>
      <Tooltip title={t('components.infoSidebar.tooltip')}>
        <SquareButton onClick={handleOpen} color="secondary" size={size}>
          <InfoOutlined />
        </SquareButton>
      </Tooltip>

      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { bgcolor: 'background.main', overflowX: 'hidden' }, elevation: 0 }}
      >
        <Stack px={isDownSm ? 3 : 6} pt={3} pb={3} width={isDownSm ? '350px' : '570px'}>
          <Button
            onClick={handleClose}
            variant="text"
            color="secondary"
            startIcon={<ArrowBack />}
            size="small"
            sx={{ position: 'absolute', ml: -3 }}
          >
            {t('components.infoSidebar.return')}
          </Button>
          {content[variant]}
        </Stack>
      </Drawer>
    </>
  )
}

export default InfoSidebar
